const getBaseUrl = (): string => {
  const apiUrl = import.meta.env.REACT_APP_API_URL || 'http://localhost:8000';
  return apiUrl;
};

export const API_CONFIG = {
  BASE_URL: getBaseUrl(),
  ENDPOINTS: {
    PROJECTS: '/api/project',
    SEARCH_WIKI: '/api/common/search_wiki',
    SEARCH_GUIDELINES: '/api/common/search_guidelines',
    SEARCH_USER_DOCS: '/api/common/search_user_docs',
    FEEDBACK: '/api/feedback',
  },
  TIMEOUT: 70000,
  LONG_RUNNING_TIMEOUT: 300000, // 5 minutes for long-running agent operations
} as const;
